import * as _ from 'lodash';
import { _values } from '@epihub/core/src/fn/object';

export const _keyBy = _.keyBy;
export const _groupBy = _.groupBy;
export const _isArray = _.isArray;
export const _uniqBy = _.uniqBy;
export const _uniq = _.uniq;
export const _last = _.last;
export const _flatten = _.flatten;
export const _sortBy = _.sortBy;
export const _chunk = _.chunk;

export function asArray<T>(itemOrArray: T | T[]): T[] {
  return _isArray(itemOrArray) ? itemOrArray : [itemOrArray];
}

export function expectOnlyOne<T>(itemOrArray: T | T[]): T {
  const arr = asArray(itemOrArray);
  if (arr.length > 1) {
    throw new Error('Expected only one');
  }
  return arr[0] as T;
}

export function arrayClear<T>(arr: T[]): T[] {
  arr.splice(0, arr.length);
  return arr;
}

export function uniqByReverse<T>(arr: T[], keyFn: (val: T) => string): T[] {
  const seenKeys = new Set<string>();
  const result = [] as T[];

  // Traverse the array from end to start
  for (let i = arr.length - 1; i >= 0; i--) {
    const item = arr[i];
    const key = keyFn(item);

    if (!seenKeys.has(key)) {
      seenKeys.add(key);
      result.unshift(item);
    }
  }

  return result;
}

export function mutateRemoveAtIndex<T>(arr: T[], index: number): T[] {
  index > -1 && arr.splice(index, 1);
  return arr;
}

export function fpRemoveAtIndex<T>(arr: T[], index: number): T[] {
  const dup = [...arr];
  index > -1 && dup.splice(index, 1);
  return dup;
}

export function fpPush<T>(arr: T[], item: T, index: number = arr.length - 1): T[] {
  const dup = [...arr];
  dup.splice(index, 0, item);
  return dup;
}

export function enumToArray<E>(enumme: any): E[] {
  const vals = _values(enumme);
  return vals;
}
